import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { useSite } from "../../../hooks/SiteProvider";
import { useEditor } from "../../../hooks/EditorProvider";
const DraggableImageSlider = ({ item: { id, props }, elementId, ...rest }) => {
    const { repeatableItem } = useSite();
    const { mode } = useEditor();
    const productionData = repeatableItem?.values.find((v) => v.field.identifier === props?.repeatableField)?.value;
    const sliderData = mode === "production"
        ? productionData
            ? JSON.parse(productionData)
            : []
        : [
            {
                src: "https://placehold.co/600x400?text=Placeholder",
            },
            {
                src: "https://placehold.co/600x400?text=Placeholder",
            },
            {
                src: "https://placehold.co/600x400?text=Placeholder",
            },
        ];
    return (_jsx(Swiper, { navigation: true, modules: [Navigation, Pagination], slidesPerView: 1.2, spaceBetween: 10, watchOverflow: true, pagination: {
            clickable: true,
            dynamicBullets: true,
        }, "editor-key": id, "editor-repeatable-field": props?.repeatableField, "editor-has-child": "true", "editor-type": "imageSlider", children: _jsx(_Fragment, { children: sliderData?.map((image, index) => (_jsx(SwiperSlide, { "editor-focuskey": id, children: _jsx("div", { className: "swiper-slide-item", "editor-focuskey": id, 
                    // src={image?.src}
                    style: {
                        backgroundImage: `url(${image?.src})`,
                    } }) }, index))) }) }));
};
export default DraggableImageSlider;
//# sourceMappingURL=DraggableImageSlider.js.map